<template>
  <a
    :href="url"
    class="flex h-full flex-col justify-end"
    @click="$emit('on-item-click', hit)"
  >
    <div class="flex h-full flex-col justify-center">
      <img
        v-if="hit.image_url"
        v-lazy="{
          src: hit.image_url,
        }"
        :class="{ 'opacity-100': isImageLoaded, 'opacity-0': !isImageLoaded }"
        class="transition-all duration-200 ease-in-out"
        @load="isImageLoaded = true"
      />
    </div>
    <div class="md:text-1xl mt-1 flex h-fit items-end text-lg font-bold">
      <span class="truncate">
        {{ hit.name }}
      </span>
    </div>
    <ProductPrice :item="hit" />
  </a>
</template>

<script setup lang="ts">
import ProductPrice from '@/components/Algolia/ProductPrice.vue';
import { AlgoliaHit } from '@/types/Algolia/AlgoliaHit';
import { computed, ref } from 'vue';

const isImageLoaded = ref(false);

export type ProductHitType = {
  hit: AlgoliaHit;
};

const props = defineProps<ProductHitType>();
defineEmits<{
  'on-item-click': [item: AlgoliaHit];
}>();

const url = computed(() => `${window.BASE_URL}${props.hit.url_key}`);
</script>
